//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
import { CosMixin } from '@/mixins/cos';
import {cloneDeep, merge, isNil} from 'lodash';
import {  AI_AGENT_TOOL_CUSTOM_TYPE } from '@/utils/constant';

const defaultForm = {
  name: '',
  type: '',
  description: '',
  reference: '',
};

export default {
  name: 'CreateEditTool',
  components: { Drawer },
  props: {
    row: {type: Object, default: () => {} },
    type: {type: String, default: 'create' },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [CosMixin],
  data() {
    return {
      AI_AGENT_TOOL_CUSTOM_TYPE,
      form: cloneDeep(defaultForm),
      agentTool: {},
      inputCategoryVisible: false,
      inputCategoryValue: '',
      toolParam: [],
      rules: {
        name: [
          { required: true, message: '请输入工具名称', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' },
        ],
        reference: [
          {
            validator: (rule, value, callback) => {
              if(!value) {
                callback(new Error(`请选择${AI_AGENT_TOOL_CUSTOM_TYPE[this.form.type]}`));
              } else{
                callback();
              }
            },
            trigger: 'change',
          },
          { required: true, trigger: 'change' },
        ],
      }
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        if(this.type === 'edit') {
          this.form =merge(cloneDeep(defaultForm), this.resetData(cloneDeep(this.row)));
        } else {
          this.form = cloneDeep(defaultForm);
        }
        this.getToolParam();
      }
      this.$nextTick(()=>{
        this.$refs?.form?.clearValidate();
      });
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close');
    },
    resetData(formData) {
      return formData;
    },
    handleClose(tag) {
      this.form.tags.splice(this.form.tags.indexOf(tag), 1);
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          const formData = cloneDeep(this.form);
          formData.instruction = isNil(formData.instruction) || formData.instruction === '' ? undefined : formData.instruction;
          console.log('submit data: ', formData);
          this.$request({
            url: this.type === 'edit' ? this.$api.updateAgentTool : this.$api.createAgentTool,
            data: this.type === 'edit' ? {
                    id: formData.id,
                    agent_tool: formData,
            } : {
                    agent_tool: formData,
            },
          }).then((res) => {
              console.log('%c Line:154 🥕 res', 'color:#42b983', res);
              this.$emit('refresh');
              this.$message.success('保存成功');
              this.close();
          }).catch(()=>{
              this.$message.error('保存失败');
          });
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
    async handleTypeChange() {
      this.$set(this.form, 'reference', '');
      this.$nextTick(()=>{
        this.$refs?.form?.clearValidate(['reference']);
      });
      await this.getToolParam();
    },
    async getToolParam() {
      this.toolParam = [];
      if(!this.form.type) return;
      const r = await this.$request({
        url: this.$api.listAgentToolsInputAndOutput,
        data: {
          type: this.form.type,
          offset: 0,
          limit: 9999999,
        },
      });
      this.toolParam = r.tool_param || [];
    },
  },
};
